/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// Компоненты пользовательского интерфейса
import '../../styles/DeviceDeployment.css';
import CustomButton from '../CustomElements/CustomButton';
import Selector from '../CustomElements/Selector';
import DateSelector from '../CustomElements/DateSelector';
import CustomTitle from '../CustomElements/CustomTitle';
import CustomTextarea from '../CustomElements/CustomTextarea';
import FormContainer from '../CustomElements/FormContainer';
import CustomContainer from '../CustomElements/CustomContainer';
import FilePicker from '../FileManager/FilePicker';

// Кастомные хуки
import { useButtonValidation } from '../../customHook/useButtonValidation';
import useOptionsLoader from '../../customHook/useOptionsLoader';
import useSuccessListener from '../../customHook/useSuccessListener';
// Утилиты
import { convertToDate, transformFieldsToMoscowStart } from '../../utils/convertToDate';
import { handleUniversalChange } from '../../utils/formUtils';
import { omitFields } from '../../utils/omitFields';
import { removeEmptyStrings } from '../../utils/removeEmptyStrings';
import { convertStringValuesToNumbers } from '../../utils/convertStringValuesToNumbers';
// Действия Redux
import { transferDeviceForOperation } from '../../redux/actions/devices.action';
import { initOptionsFromServer } from '../../redux/actions/options.action';
import { load } from '../../redux/actions/loader.action';
import {
  initDepartmentOptionsFromServer,
  initOptionsBrigadesFromServer,
  initOptionsDirectoratesFromServer,
  initOptionsEmployeesFromServer,
} from '../../redux/actions/options.action';

//компонент формы выдачи устройства в эксплуатацию

function TransferDeviceToUsage({ currentDevice, closeModal, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  // получаем опции из стора
  const { roads, departments, employees, workers, brigadeNames, directorates } = useSelector((state) => state.options);

  // Состояние для формы. Мемоизируем начальные данные формы
  const initialFormData = useMemo(
    () => ({
      deviceId: currentDevice.id,
      date: '',
      brigadeNameId: '',
      acceptanceCert: null,
      senderId: '',
      responsibleId: '',
      responsibleContact: '',
      road: '',
      departmentId: '',
      directorateId: '',
      typeId: currentDevice?.typeId,
    }),

    [currentDevice]
  );
  const [formData, setFormData] = useState(initialFormData);

  //хук для запроса опций для дирекций и контроля селекта
  const messageForSelectDirectorates = 'Выберите дорогу';
  const directoratesControl = useOptionsLoader(
    formData,
    setFormData,
    ['directorateId', 'departmentId', 'responsibleId', 'brigadeNameId'],
    'road',
    initOptionsDirectoratesFromServer,
    messageForSelectDirectorates
  );

  //хук для запроса опций для подразделений и контроля селекта
  const messageForSelectDepartments = 'Выберите дирекцию';
  const departmentsControl = useOptionsLoader(
    formData,
    setFormData,
    ['responsibleId', 'departmentId', 'brigadeNameId'],
    'directorateId',
    initDepartmentOptionsFromServer,
    messageForSelectDepartments
  );

  //хук для запроса опций для ФИО ответственного и контроля селекта
  const messageForSelectWorkers = 'Выберите подразделение';
  const workersControl = useOptionsLoader(
    formData,
    setFormData,
    ['responsibleId'],
    'departmentId',
    initOptionsEmployeesFromServer,
    messageForSelectWorkers
  );

  //хук для запроса опций для наименования бригад и контроля селекта
  const messageForSelectBrigades = 'Выберите подразделение';
  const brigadesControl = useOptionsLoader(
    formData,
    setFormData,
    ['brigadeNameId'],
    'departmentId',
    initOptionsBrigadesFromServer,
    messageForSelectBrigades
  );

  /** Функция для проверки валидности формы */
  const isButtonDisabled = useButtonValidation(formData, ['responsibleContact']);

  // Обработчик отправки формы
  const handlerSubmit = (event) => {
    event.preventDefault();
    //переводим в состояние загрузки
    dispatch(load());
    // Удаляем поля, которые не нужно отправлять
    const formWithoutExcluded = omitFields(formData, ['deviceId', 'acceptanceCertName', 'roadId', 'directorateId']);
    // Удаляем пустые строки
    const formWithoutEmptyStrings = removeEmptyStrings(formWithoutExcluded);
    const transformedPayload = convertStringValuesToNumbers(formWithoutEmptyStrings, ['responsibleId']);
    // Преобразуем указанные поля в начало дня по Москве
    const payload = transformFieldsToMoscowStart(transformedPayload, ['date']);
    // Отправляем данные на сервер через Redux
    dispatch(
      transferDeviceForOperation({
        payload,
        deviceId: formData?.deviceId,
        typeId: formData?.typeId,
        isUipps: false,
        path: 'usage',
      })
    );
  };

  //отслеживаем выполнение запроса
  useSuccessListener(setFormData, initialFormData, closeModal);

  useEffect(() => {
    return () => {
      dispatch(initOptionsFromServer());
    };
  }, []);

  return (
    <CustomContainer>
      <CustomTitle
        titleText={t?.deviceIssuanceTitle || 'ВЫДАЧА В ЭКСПЛУАТАЦИЮ УСТРОЙСТВА'}
        deviceType={currentDevice.type}
        deviceId={currentDevice.id}
      />
      <FormContainer>
        <DateSelector
          column="left"
          width="100%"
          height="var(--sadr-font-size-60)"
          label={t?.labelIssueDate || 'Дата выдачи в эксплуатацию *'}
          placeholder={t?.placeholderSelectDate || 'Выберите дату'}
          selectedDate={formData.date}
          setSelectedDate={(date) => handleUniversalChange(formData, setFormData, null, 'date', date, 'date')}
          name="date"
          minDate={convertToDate(currentDevice?.lastActionDate)}
          maxDate={new Date()}
        />
        <Selector
          column="left"
          options={employees}
          onChange={(selectedOption) => {
            handleUniversalChange(formData, setFormData, null, 'senderId', selectedOption, 'select');
          }}
          label={t?.labelEmployeeIssued || 'ФИО выдавшего в эксплуатацию *'}
          placeholder={t?.placeholderSelectEmployee || 'Выберите ФИО'}
          width="100%"
          height="var(--sadr-font-size-60)"
          value={employees?.find((option) => option.value === formData.senderId)}
          isMulti={false}
          name="senderId"
        />
        <FilePicker
          column="left"
          label={t?.labelAcceptanceCert || 'Акт приема-передачи *'}
          formData={formData}
          setFormData={setFormData}
          fieldName="acceptanceCertName"
          fieldIdName="acceptanceCert"
          rowSpan={2}
        />
        <Selector
          column="right"
          options={roads}
          onChange={(selectedOption) => {
            handleUniversalChange(formData, setFormData, null, 'road', selectedOption, 'select');
          }}
          label={`${t?.labelRoad} *` || 'Дорога *'}
          placeholder={t?.placeholderRoad || 'Выберите дорогу'}
          width="100%"
          height="var(--sadr-font-size-60)"
          value={
            formData.road
              ? roads?.find((option) => option.value === formData.road)
              : roads?.find((option) => option.label === formData.road)
          }
          isMulti={false}
          name="road"
        />

        <Selector
          column="right"
          options={directorates}
          onChange={(selectedOption) => {
            handleUniversalChange(formData, setFormData, null, 'directorateId', selectedOption, 'select');
          }}
          label={`${t?.labelDirectorate} *` || 'Дирекция *'}
          placeholder={t?.placeholderDirectorate || 'Выберите дирекцию'}
          value={
            formData.directorateId ? directorates?.find((option) => option.value === formData.directorateId) : null
          }
          isMulti={false}
          name="directorateId"
          width="100%"
          height="var(--sadr-font-size-60)"
          isDisabled={directoratesControl?.isSelectorDisabled}
          message={directoratesControl?.message}
          customClick={directoratesControl?.onSelectorChange}
        />
        <Selector
          column="right"
          options={departments}
          onChange={(selectedOption) => {
            handleUniversalChange(formData, setFormData, null, 'departmentId', selectedOption, 'select');
          }}
          label={`${t?.labelDepartment} *` || 'Подразделение *'}
          placeholder={t?.placeholderSelectDepartment || 'Выберите подразделение'}
          width="100%"
          height="var(--sadr-font-size-60)"
          value={
            formData.departmentId && departments
              ? departments?.find((option) => option.value === formData.departmentId)
              : null
          }
          isMulti={false}
          name="departmentId"
          isDisabled={departmentsControl?.isSelectorDisabled}
          message={departmentsControl?.message}
          customClick={departmentsControl?.onSelectorChange}
        />
        <Selector
          column="right"
          options={brigadeNames}
          onChange={(selectedOption) => {
            handleUniversalChange(formData, setFormData, null, 'brigadeNameId', selectedOption, 'select');
          }}
          label={t?.labelBrigadeName || 'Наименование бригады *'}
          placeholder={t?.placeholderSelectBrigadeName || 'Выберите наименование бригады'}
          width="100%"
          height="var(--sadr-font-size-60)"
          value={
            formData.brigadeNameId ? brigadeNames?.find((option) => option.value === formData?.brigadeNameId) : null
          }
          isMulti={false}
          name="brigadeNameId"
          isDisabled={brigadesControl?.isSelectorDisabled}
          message={brigadesControl?.message}
          customClick={brigadesControl?.onSelectorChange}
        />
        <Selector
          column="right"
          options={workers}
          onChange={(selectedOption) => {
            handleUniversalChange(formData, setFormData, null, 'responsibleId', selectedOption, 'select');
          }}
          label={t?.labelResponsibleEmployee || 'ФИО ответственного лица *'}
          placeholder={t?.placeholderSelectEmployee || 'Выберите ФИО'}
          width="100%"
          height="var(--sadr-font-size-60)"
          value={formData.responsibleId ? workers?.find((option) => option.value === formData.responsibleId) : null}
          isMulti={false}
          name="responsibleId"
          isDisabled={workersControl?.isSelectorDisabled}
          message={workersControl?.message}
          customClick={workersControl?.onSelectorChange}
        />
        <CustomTextarea
          column="right"
          type="textArea"
          onChange={(event) => handleUniversalChange(formData, setFormData, event)}
          name="responsibleContact"
          label={t?.labelResponsibleContact || 'Контакты ответственного лица'}
          placeholder={t?.placeholderResponsibleContact || 'Введите контакты ответственного лица'}
          rowSpan={2}
          width="100%"
          height="var(--sadr-font-size-150)"
          value={formData.responsibleContact}
          maxLength={30}
        />
        <CustomButton
          onClick={(event) => {
            handlerSubmit(event);
          }}
          width="var(--sadr-font-size-420)"
          height="var(--sadr-font-size-60)"
          text={t?.issueDeviceButton || 'Выдать устройство'}
          disabled={isButtonDisabled}
          isButton
        />
      </FormContainer>
    </CustomContainer>
  );
}

export default TransferDeviceToUsage;
